import { render } from "./ClientTallerOrdenes.vue?vue&type=template&id=72dc2660&scoped=true"
import script from "./ClientTallerOrdenes.vue?vue&type=script&lang=js"
export * from "./ClientTallerOrdenes.vue?vue&type=script&lang=js"

import "./ClientTallerOrdenes.vue?vue&type=style&index=0&id=72dc2660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dc2660"]])

export default __exports__